<template>
  <div class="find-tag__controls" :class="[inputSize]">
    <div class="find-tag__input input" :class="[inputSize]">
      <div class="select-tags">
        <div class="new-tag__add-input-wrapper input input--grey input--search input--icon" v-if="!isBlueprint">
          <input
            v-click-outside="onOutsideDropdownClick"
            v-model="searchString"
            :placeholder="inputPlaceholder"
            type="text"
            class="new-tag__input  "
            :class="[inputSize]"
            :maxlength="maxItemNameLength"
            @keyup="inputOnKey($event, searchString)"
            @keydown.esc.prevent="hideDropdown()"
          />
        </div>
        <div v-else class="new-tag__add-button-wrapper">
          <button
            v-click-outside="onOutsideDropdownClick"
            class="new-tag__button"
            @click="openSelectBox"
          >
            <span class="open-button__text"> Select tags </span>
            <ExpandArrow class="new-tag__button-arrow"> </ExpandArrow>
          </button>
        </div>
        
      </div>
      <div
          class="dropdown-outer"
          :class="{
            open: openDrodown,
          }"
        >
            <!-- empty: options.length == 0 && allowCreate == false, -->
          <ul
            v-if="options.length > 0"
            v-infinite-scroll="loadMoreItemsOnScroll"
            class="dropdown dropdown-outer__list"
            infinite-scroll-disabled="scrollDisabled"
            infinite-scroll-distance="20"
          >
            <li
              v-for="(item, i) in options"
              :key="`selector_item_${i}`"
              class="dropdown-outer__list-item"
            >
              <a
                href="#"
                @keydown.40.prevent
                @keyup.40.prevent.stop="focusOnNext($event)"
                @keydown.38.prevent.stop="focusOnPrev($event)"
                @keydown.esc.prevent="hideDropdown()"
                @click.prevent="addNew(item)"
              >
              <span v-if="isBlueprint">{{ formatName(item.name) }}</span>
              <span v-else v-html="higlightItemName(item.name)">
              </span>
              </a>
            </li>
      
          </ul>
          <ul v-else
            class="dropdown dropdown-outer__list"
            infinite-scroll-disabled="scrollDisabled"
            infinite-scroll-distance="20"
          >
        

            <li
              class="dropdown-outer__list-item"

            >
              <a
                href="#"
                class="disabled"
                @click.prevent.stop
                @keydown.esc.prevent="hideDropdown()"
              >
                <BanIcon class="find-tag__icon-add icon-no-tags" />
                No match
              </a>
            </li>

            <!-- <template v-if="allowCreate"> -->
              <li
                class="dropdown-outer__list-item"
                 v-if="allowCreateItemMenuItemVisible"

              >
                <a
                  href="#"
                  @keyup.40.prevent.stop="focusOnNext($event)"
                  @keydown.38.prevent.stop="focusOnPrev($event)"
                  @keydown.esc.prevent="hideDropdown()"
                  @click.prevent.stop="createItem(searchString)"
                >
                  <DocumentAddIcon class="find-tag__icon-add icon-add-tag" />
                  Add new item
                </a>
              </li>

              <li v-if="validateError">
                <a
                  href="#"
                  class="disabled"
                  @click.prevent.stop
                  @keydown.esc.prevent="hideDropdown()"
                >
                  <BanIcon class="find-tag__icon-add icon-no-tags" />
                  {{ validateError }}
                </a>
              </li>
            <!-- </template> -->
          </ul>
        </div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import DocumentAddIcon from 'Svgs/plus.svg?inline';
import ExpandArrow from 'Svgs/expand-arrow.svg?inline';

const MAX_ITEM_NAME_LENGTH = 50;
const MIN_ITEM_NAME_LENGTH = 3;

export default {
  name: 'BaseSelector',
  directives: { infiniteScroll },
  components: { DocumentAddIcon, ExpandArrow },
  props: {
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    inputPlaceholder: {
      type: String,
      default: 'Type a tag',
    },
    icon: {
      type: String,
      default: 'tag-o',
    },
    size: {
      type: String,
      default: '',
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    isBlueprint: {
      type: Boolean,
      default: false,
    },
    maxItems: {
      type: Number,
      default: 10,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    inputRegexp: {
      type: RegExp,
      default: () => {
        return /^[a-zA-Z0-9\s]*$/;
      },
    },
  },
  mounted() {
    this.items;
  },
  data() {
    return {
      searchString: '',
      openDrodown: false,
      itemIds: [],
      page: 1,
      isOpen: false,
      maxItemNameLength: MAX_ITEM_NAME_LENGTH,
      validateError: null,
    };
  },
  computed: {

    allowCreateItemMenuItemVisible() {
      if (!this.allowCreate || this.options.length >= this.maxItems) {
        return false;
      }

      const itemInputName = this.searchString.toLowerCase();
      const itemInputNameLength =
        itemInputName.length >= MIN_ITEM_NAME_LENGTH &&
        itemInputName.length <= MAX_ITEM_NAME_LENGTH;
      const itemNameConsistLetterOrNum =
        /^[\w .]+$/.test(itemInputName) && /[0-9a-zA-Z]/.test(itemInputName);
      let alreadyChosen = false;

      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].name === itemInputName) {
          alreadyChosen = true;
          break;
        }
      }
      return (
        itemInputNameLength && itemNameConsistLetterOrNum && !alreadyChosen
      );
    },
    scrollDisabled() {
      return this.page >= this.totalPages;
    },
    inputSize() {
      return this.size ? `input--${this.size}` : '';
    },
    loading() {
      return this.$store.state.authors.loading;
    },
  },
  mounted() {
    window.addEventListener('click', this.hideDropdownClick);
  },
  destroyed() {
    window.removeEventListener('click', this.hideDropdownClick);
  },
  methods: {
    formatName(name) {
        const str = name.replace(/.*_/gi, '');
        return str;
    },
    onOutsideDropdownClick(evt) {
      this.hideDropdown();
    },
    itemInSelectionByName(tagName) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.items[i].name.toLowerCase() === tagName.toLowerCase()) {
          return true;
        }
      }
      return false;
    },
    addNew(item) {
      if (item) {
        this.$emit('add', item);
      }
      this.searchString = '';
    },
    createItem(text) {
      this.addNew({ name: text.toLowerCase() }, true);
    },
    openSelectBox() {
      this.openDrodown = true;
      // this.validateInput(val);
      this.page = 1;
      // this.$emit('search', val, this.page);
    },
    inputOnKey(e, val) {
      // if ESC
      if (e.keyCode === 27) {
        e.target.blur();
        return this.hideDropdown();
      }
      // if arrow key down
      if (e.keyCode === 40) {
        if (!val.length && !this.openDrodown) {
          this.page = 1;
          this.$emit('search', val, this.page);
          this.openDrodown = true;
          return;
        }

        if (this.openDrodown) {
          return this.focusOnDropdown(e);
        }
      }

      // if ENTER
      if (e.keyCode === 13) {
        if (!val.length) {
          this.openDrodown = true;
          return;
        }
        if (this.openDrodown) {
          return (this.openDrodown = false);
        }
        return e.preventDefault();
      }

      if (this.allowCreate) {
        this.validateInput(val);
      }

      if (val.length > 0) {
        this.openDrodown = true;
        this.validateInput(val);
        this.page = 1;
        this.$emit('search', val, this.page);
      } else {
        this.openDrodown = false;
      }
    },
    focusOnDropdown(e) {
      e.target.parentNode.querySelector('ul li a').focus();
    },
    focusOnNext(e) {
      const nextSibling = e.target.parentNode.nextElementSibling;
      if (nextSibling !== null) {
        nextSibling.firstChild.focus();
      }
    },
    focusOnPrev(e) {
      const prevSibling = e.target.parentNode.previousElementSibling;
      if (prevSibling !== null) {
        prevSibling.firstChild.focus();
      }
    },
    hideDropdown() {
      if (!this.openDrodown) {
        return;
      }
      this.openDrodown = false;
    },
    hideDropdownClick(e) {
      const input = this.$el.querySelector('.new-tag__button');
      if (this.openDrodown && e.target != input) {
        // this.openDrodown = false;
      }
    },
    higlightItemName(name) {
      const inputVal = this.searchString.toLowerCase();

      const formattedName = this.formatName(name)

      if (inputVal.length < 1) return formattedName;

      const reg = new RegExp('(' + inputVal + ')', 'i');
      return formattedName.replace(reg, `<span class="highlited">$1</span>`);
    },
    loadMoreItemsOnScroll() {
      this.page++;
      this.$emit('scroll', this.searchString, this.page);
    },
    validateInput(val) {
      const isProperLength =
        val.length >= MIN_ITEM_NAME_LENGTH &&
        val.length <= MAX_ITEM_NAME_LENGTH;

      if (!isProperLength) return;

      if (!this.validateInputCharacters(val)) {
        this.validateError = 'Wrong format';
        return;
      }

      if (!this.validateInputMaxLength(val)) {
        this.validateError = 'Name is too long';
        return;
      }

      if (this.itemInSelectionByName(val)) {
        this.validateError = 'Already selected';
        return;
      }

      if (this.validateError) this.validateError = null;
    },
    validateInputCharacters(val) {
      return this.inputRegexp.test(val);
    },
    validateInputMaxLength(val) {
      return val.length <= MAX_ITEM_NAME_LENGTH;
    },
  },
};
</script>
<style lang='scss' scoped>
.find-tag__controls {
  width: 25%;
  height: auto;
}
// .new-tag__add-button {
//     height: inherit;
//     display: flex;
//     justify-content: center;
//     align-items: center;
// }
.new-tag__button {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  position: relative;
  padding: 0 20px 0 20px;
  align-items: left;
  font-size: 0.8rem;
  background: white;
  border-radius: 0.5em;
  border-width: 1px;
  letter-spacing: 0.07px;
  border: 1px solid #989898;
  width: 100%;
  height: 45px;

  & .new-tag__button-arrow {
    fill: #989898
  }
}
.new-tag__input {
  height: 45px !important;
    border: 1px solid #989898;

        &::placeholder {
            color: #989898;
        }
}
.new-tag__add-input-wrapper {
  width: 100%;
}
.new-tag__add-button-wrapper {
  width: 100%;
}
.open-button__text {
  display: block;
}
.new-tag__button-arrow {
  display: block;
  height: 10px;
}
.select-tags {
  width: 100%;
  display: flex;
  position: relative;
  justify-content: start;
  align-items: center;
}
.dropdown-outer {
    position: absolute;
    width: 100%;
    height: auto;
    max-height: 300px;
    z-index: 10;
    top: 3.7em;
    left: 0;
    display: none;
    font-size: 1em;
    background-color: #fff;
    border: 1px solid #999;
    border-radius: 0.1em;
    box-shadow: 0 0 7px 1px rgba($blue-main, 0.5);

    &.open {
        display: block;

        &::after {
            content: '';
            position: absolute;
            top: -6px;
            left: em(18);
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 6px solid #fff;
        }
    }

    &:empty {
        border: 0;

        &::after {
            display: none;
        }
    }
}
</style>
